<template>
    <div>
        <app-sub-title text="Encuestas de satisfacción"/>
        <b-button variant="primary" @click="startSave" class="btn-block-xs-only"><i class="fa fa-plus" aria-hidden="true"></i> Crear encuesta de satisfacción </b-button>
        <app-satisfaction-poll-filters
            @filter="onFilter"
            :accessPoints="accessPoints"
        />
        <app-satisfaction-polls-list
            :data="data"
            @change-page="changePage"
            @remove-poll="startRemove"
            @see-card="seeCard"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->
        <app-pop-up title="Encuesta de satisfacción" size="large" id="satisfaction-poll-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <!-- <app-satisfaction-poll-form v-if="theReport" :onSave="onSaveSatisfactionPoll" :theClientId="clientId" :theReportId="theReport.id"/> -->
                <app-satisfaction-poll-form :theClientId="theClient.id" :onSave="onSave" />
            </div>
            <div slot="buttons">
                <b-button variant="confirm" :disabled="inProgress" class="btn-block-xs-only" @click="$bus.$emit('satisfaction-poll.save')"><i class="fa fa-floppy-o"></i> Guardar encuesta</b-button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="satisfaction-poll-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar esta encuesta de satisfacción?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteSatisfactionPoll(selectedPoll)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>

        <app-pop-up title="Encuesta de satisfacción" size="large" id="satisfaction-poll-card">
            <div slot="body">
                <app-satisfaction-poll-card v-if="selectedPoll" :satisfaction-poll="selectedPoll"
                />
            </div>
        </app-pop-up>
        <!-- fin de pop ups -->
    </div>
</template>

<script>
import satisfactionPollRepository from '../../../../../repositories/satisfactionPoll.repository';
import structuresRepository from '../../../../../repositories/structures.repository.js';
import SatisfactionPollsList from './SatisfactionPollsList/SatisfactionPollsList.vue';
import SatisfactionPollFilters from './SatisfactionPollFilters/SatisfactionPollFilters.vue';
import SatisfactionPollForm from './SatisfactionPollForm/SatisfactionPollForm.vue';
import SatisfactionPollCard from './SatisfactionCard/SatisfactionCard.vue';
export default {
    components: {
        appSatisfactionPollsList: SatisfactionPollsList,
        appSatisfactionPollForm: SatisfactionPollForm,
        appSatisfactionPollFilters: SatisfactionPollFilters,
        appSatisfactionPollCard: SatisfactionPollCard
    },
    props: {
        theClient: {
            type: Object,
            default: null
        },
    },
    data(){
        return {
            data: {},
            filters: {},
            selectedPoll: '',
            page: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            accessPoints: []
        }
    },
    methods: {
        loadSatisfactionPolls(){
            const spr = {...satisfactionPollRepository};
            //listar por cliente
            const filters = {...this.filters, client: this.theClient.id, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir}
            spr.loadSatisfactionPolls(filters, this.page)
                .then(({data}) => {
                    this.data = data;
                })
                .catch(error => toastr.error('Error al listar las encuentas de satisfacción'));
        },
        loadAccessPoints(){
            const sr = {...structuresRepository};
            sr.accessPointsByClient(this.theClient.id)
            .then(data => {
                const newAccessPoints = [];
                data.map(item => {
                    const accessPoint = {
                        ...item,
                        name: item.name + ' ('+item.venue.name+')'
                    }
                    newAccessPoints.push(accessPoint);
                })
                this.accessPoints = newAccessPoints;
            })
            .catch(error => toastr.error('Error al cargar los puntos de acceso'));
        },
        onFilter(filters){
            this.filters = filters;
            this.loadSatisfactionPolls();
        },
        changePage(page){
            this.page = page;
            this.loadSatisfactionPolls();
        },
        startSave(){
            this.selectedPoll = '';
            this.$bus.$emit('satisfaction-poll-form.open');
        },
        seeCard(satisfactionPoll){
            this.selectedPoll = satisfactionPoll;
            this.$bus.$emit('satisfaction-poll-card.open');
        },
        onSave() {
            this.$bus.$emit('satisfaction-poll-form.close');
            this.loadSatisfactionPolls();
        },
        startRemove(satisfactionPoll){
            this.selectedPoll = satisfactionPoll;
            this.$bus.$emit('satisfaction-poll-remove.open');
        },
        deleteSatisfactionPoll(satisfactionPoll) {
            const spr = {...satisfactionPollRepository};
            spr.deleteSatisfactionPoll(satisfactionPoll.id)
                .then(({data}) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadSatisfactionPolls();
                        this.$bus.$emit('satisfaction-poll-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar la encuesta de satisfacción');
                });
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadSatisfactionPolls();
        },
        cleanForm() {
            this.$bus.$emit('satisfaction-poll.clean');
        },
        initialize(){
            this.loadSatisfactionPolls();
            this.loadAccessPoints();
        }
    },
    created(){
        this.initialize();
    }
}
</script>